import jQuery from 'jquery';
import 'bootstrap/js/dist/modal';
import { globalWindow } from '../utils/constants';
import { resizeObserver } from '../utils/helpers';

globalWindow.loadYTvideoModal = function (videoURL: string) {
  const url = videoURL;
  const $videoModal = jQuery('#videoModal');
  $videoModal.on('show.bs.modal', function () {
    jQuery('#ytVideo').attr('src', `${url}?&amp;autoplay=1`);
  });
  $videoModal.on('hide.bs.modal', function () {
    jQuery('#ytVideo').attr('src', '');
  });
};

window.addEventListener('DOMContentLoaded', () => {
  resizeObserver.observe(document.body);
});

export {};
